export const selectStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    minHeight: '2.6rem',             
    border: '1px solid #000',     
    borderRadius: '0.10rem',       
    boxShadow: 'none',           
    fontSize: '0.875rem',        
    padding: '0 0.3rem',          
    backgroundColor: '#fff',     
    '&:hover': {
      borderColor: '#000',          
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#E5E7EB',     
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#6B7280',           
    fontSize: '0.875rem',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "white", 
    zIndex: 9999,     
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)", 
  }),
 
};

